<div class="flex flex-column gap-1">
  <eo-form-label *ngIf="isVisible()" [formId]="id" [label]="getLabel()" [required]="isRequired()" />

  <ng-content />

  <div class="flex flex-column gap-0">
    <eo-form-help-msg [formId]="id" [help]="getHelp()" />
    <eo-max-length-counter-msg [formControl]="getFormControl()" />
    <eo-validation-error-msg
      [formControl]="getFormControl()"
      [errors]="getErrors()"
    />
  </div>
</div>
